const LiveModesPricesTypes = {
    "big": "big",
    "medium": "medium",
    "small": "small",
    "default": "default"
};
var live_modes_prices = Object.freeze(LiveModesPricesTypes);

export { live_modes_prices as default };
//# sourceMappingURL=live_modes_prices.js.map
